import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
import i18n from './i18n'

// Element Plus va uning ikonkalari BU YERDA global ro'yxatga qo'yilmaydi.
//
// Ilgari shunday edi:
//     app.use(ElementPlus)                       // butun kutubxona
//     import 'element-plus/dist/index.css'       // butun CSS
//     for (...Object.entries(ElementPlusIconsVue)) app.component(...)  // 293 ikonka
//
// O'lchangan narxi: Element Plus ~325 KB gzip, ikonkalar ~34 KB gzip — ya'ni
// 506 KB lik birinchi yuklanishning uchdan ikki qismi. Ilova esa ~56 ta
// komponent va ~40 ta ikonkadan foydalanadi.
//
// Endi ular vue.config.js dagi unplugin-vue-components orqali, shablonlar
// o'qib chiqilib, TALAB BO'YICHA import qilinadi. Birorta .vue fayl
// o'zgartirilmadi va `<el-button>`, `<el-icon><Search /></el-icon>` kabi
// yozuvlar avvalgidek ishlaydi.
//
// `import { ElMessage } from 'element-plus'` shaklidagi to'g'ridan-to'g'ri
// importlarga (24 ta faylda) uslub unplugin-element-plus tomonidan
// qo'shiladi — ular o'z-o'zicha uslubsiz chiqardi.
//
// Til (locale) App.vue dagi <el-config-provider> orqali beriladi.

import { initPwa } from '@/utils/pwa'

const app = createApp(App)

// Pinia (State Management)
app.use(createPinia())

// Router
app.use(router)

// i18n
app.use(i18n)

// PWA tinglovchisi mount'dan OLDIN ulanadi — `beforeinstallprompt`
// sahifa yuklanishida ishga tushadi va kechikkan tinglovchi uni
// butunlay o'tkazib yuboradi.
initPwa()

app.mount('#app')

// Service worker — ilovani telefonga o'rnatish uchun SHART (brauzer manifest
// va fetch ishlovchisi bo'lgan worker ikkalasini ham talab qiladi).
//
// `load` hodisasidan keyin ro'yxatdan o'tkaziladi: registratsiya tarmoqqa
// chiqadi va ilovaning birinchi yuklanishi bilan poyga qilmasin.
//
// Faqat production'da. Dev serverda service worker eski bundle'ni ushlab
// qolib, tahrir qilingan kod ko'rinmay qolishiga sabab bo'ladi.
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((err) => {
      // Ro'yxatdan o'tmasa ilova oddiy sayt sifatida ishlayveradi —
      // faqat o'rnatib bo'lmaydi. Bu yiqilish emas, shuning uchun
      // foydalanuvchiga xabar ko'rsatilmaydi.
      console.warn("Service worker ro'yxatdan o'tmadi:", err)
    })
  })
}
